<template>
    <div class="contacts-info">
      <header class="entry-subheader">
            <v-icon class="icon-style">phone</v-icon>
            <h2 class="entry-subtitle">my contacts</h2>
        </header>
      <v-row>
        <v-col>
          <div class="description">
            <p style="text-indent: 25px; " align="justify">
              If you have any questions regarding new offers, you have ambitious and interesting idea for web application or your dealings with me, please do not hesitate to contact at the below-mentioned address, e-mail address or phone number.
            </p>
          </div>
        </v-col>
      </v-row>
      <v-row style="margin-top:-35px">
        <v-col>
          <div class="note-row">
            <v-icon class="icon-row">location_on</v-icon>
            <h5>5525 Wigeon St SE Salem, OR</h5>
          </div>
          <div class="note-row">
            <v-icon class="icon-row">ring_volume</v-icon>
            <a href="tel:(720) 292-7117"><h5>(720) 292-7117</h5></a>
          </div>
          <div class="note-row">
            <div class="icon-row" style="margin-top: -5px">
              <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 33.866667 33.866667"
                  height="30"
                  width="30">
                <g transform="translate(223.30833,-34.471382)" id="layer1">
                  <g
                      style="fill:#e65100;fill-opacity:1"
                      transform="matrix(0.43421826,0,0,0.4055436,-218.01625,38.175407)"
                      id="g880">
                    <path
                        style="fill:#e65100;fill-opacity:1"
                        d="M 28.664,0.008 C 26.027,0.078 23.373,0.629 20.85,1.538 11.079,5.616 4.284,14.514 1.21,25.19 0.691,27.194 0.27,29.2 0.044,31.27 c 0,0.067 -0.162,2.105 0.129,1.555 0.291,-0.484 0.42,-1.197 0.582,-1.748 C 2.243,26.063 4.057,21.5 6.839,17.165 13.505,7.36 24.214,1.052 35.537,4.547 c 2.104,0.71 3.98,1.747 5.856,2.976 0.355,0.259 2.976,2.33 2.394,0.453 C 43.302,6.49 42.073,5.225 41.004,4.222 37.406,1.108 33.06,-0.109 28.664,0.008 Z m -2.55,12.505 c -1.367652,-0.03578 -2.722298,0.273389 -3.939,0.899 -4.044,2.037 -5.663,6.987 -3.592,11.031 2.038,4.045 6.986,5.664 11.031,3.594 4.044,-2.039 5.662,-6.989 3.592,-11.031 -1.354861,-2.690636 -4.080447,-4.417378 -7.092,-4.493 z m 5.54,19.956 c -2.59,1.55 -5.63,2.425 -8.865,2.425 -0.678,0 -1.326,-0.031 -2.006,-0.097 v 23.812 c 0,2.2 0.518,3.85 1.522,4.951 1.035,1.132 2.298,1.682 3.883,1.682 1.616,0 2.945,-0.55 3.945,-1.65 1.005,-1.1 1.521,-2.75 1.521,-4.983 V 32.47 Z"
                        fill="#2164f3"
                        fill-rule="evenodd"
                        id="path868" />
                  </g>
                </g>
              </svg>
            </div>
            <a href="https://my.indeed.com/p/eugenee-iy2yr4y"><h5>indeed.com/p/eugenee-iy2yr4y</h5></a>
          </div>
          <div class="note-row">
            <div class="icon-row">
              <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 33.866667 33.866667"
                  height="25"
                  width="25">
                <g transform="translate(223.30833,-34.471382)" id="layer1">
                  <path
                      transform="matrix(0.26458334,0,0,0.26458334,-223.30833,34.471382)"
                      d="M 63.703125 0 A 64.000003 64.000003 0 0 0 0 64 A 64.000003 64.000003 0 0 0 64 128 A 64.000003 64.000003 0 0 0 128 64 A 64.000003 64.000003 0 0 0 64 0 A 64.000003 64.000003 0 0 0 63.703125 0 z M 25.03125 37.742188 L 36.28125 37.742188 L 36.28125 55.148438 C 38.28125 53.58594 40.197927 52.38802 42.03125 51.554688 C 43.885411 50.721356 45.937497 50.304686 48.1875 50.304688 C 51.979147 50.304688 54.937498 51.408859 57.0625 53.617188 C 59.208339 55.825518 60.28125 59.127612 60.28125 63.523438 L 60.28125 86.367188 L 48.96875 86.367188 L 48.96875 68.960938 C 48.96875 67.544274 48.89589 66.13802 48.75 64.742188 C 48.60411 63.325524 48.354117 62.283853 48 61.617188 C 47.583345 60.846354 46.968748 60.283854 46.15625 59.929688 C 45.364565 59.575522 44.24998 59.398436 42.8125 59.398438 C 41.791675 59.398438 40.750001 59.565105 39.6875 59.898438 C 38.645837 60.231772 37.510428 60.763022 36.28125 61.492188 L 36.28125 86.367188 L 25.03125 86.367188 L 25.03125 37.742188 z M 70.65625 37.742188 L 81.90625 37.742188 L 81.90625 55.148438 C 83.90625 53.585941 85.822927 52.38802 87.65625 51.554688 C 89.510411 50.721357 91.562497 50.304687 93.8125 50.304688 C 97.604172 50.304688 100.56252 51.40886 102.6875 53.617188 C 104.83334 55.825518 105.90625 59.127613 105.90625 63.523438 L 105.90625 86.367188 L 94.59375 86.367188 L 94.59375 68.960938 C 94.59375 67.544275 94.52089 66.13802 94.375 64.742188 C 94.22911 63.325525 93.979117 62.283853 93.625 61.617188 C 93.208345 60.846355 92.593748 60.283854 91.78125 59.929688 C 90.989565 59.575523 89.87498 59.398437 88.4375 59.398438 C 87.416675 59.398438 86.375001 59.565106 85.3125 59.898438 C 84.270837 60.231772 83.135428 60.763023 81.90625 61.492188 L 81.90625 86.367188 L 70.65625 86.367188 L 70.65625 37.742188 z "
                      style="fill:#e65100;fill-opacity:1;stroke-width:0.970991"
                      id="path886" />
                  <g
                      style="font-style:normal;font-variant:normal;font-weight:bold;font-stretch:normal;font-size:16.9333px;line-height:1.25;font-family:sans-serif;-inkscape-font-specification:'sans-serif Bold';fill:#000000;fill-opacity:1;stroke:none;stroke-width:0.264583;opacity:1"
                      id="text884"
                      aria-label="hh" />
                </g>
              </svg>
            </div>
            <a href="https://krasnodar.hh.ru/resume/343ee902ff07dd8c430039ed1f64415347594f"><h5>hh.ru/EugeneYesaulov</h5></a>
          </div>
        </v-col>
        <v-col>
          <div class="note-row">
            <v-icon class="icon-row">email</v-icon>
            <a href="mailto:eugene.yeasulov@gmail.com"><h5>eugene.yeasulov@gmail.com</h5></a>
          </div>
          <div class="note-row">
            <v-icon class="icon-row">email</v-icon>
            <a href="mailto:esaulov.eugene@yandex.ru"><h5>esaulov.eugene@yandex.ru</h5></a>
          </div>
          <div class="note-row">
            <div class="icon-row">
              <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 33.866667 33.866667"
                  height="30"
                  width="30">
                <g transform="translate(223.30833,-34.471382)" id="layer1">
                  <g
                      style="font-style:normal;font-variant:normal;font-weight:bold;font-stretch:normal;font-size:23.4798px;line-height:1.25;font-family:'Agency FB';-inkscape-font-specification:'Agency FB Bold';fill:#e65100;fill-opacity:1;stroke:none;stroke-width:0.326107"
                      id="text858"
                      transform="scale(1.2325311,0.81133853)"
                      aria-label="f">
                    <path
                        id="path863"
                        style="font-style:normal;font-variant:normal;font-weight:bold;font-stretch:normal;font-size:23.4798px;font-family:'Agency FB';-inkscape-font-specification:'Agency FB Bold';fill:#e65100;fill-opacity:1;stroke-width:0.338559"
                        d="m -164.43468,56.532151 h -2.01687 l -0.0201,3.721558 h 1.75275 l 0.0201,2.780674 h -1.75274 v 9.617641 h -2.72515 v -9.617641 h -1.24853 l -0.0201,-2.780674 h 1.24853 c 0,0 -3e-5,-1.477922 -3e-5,-3.15625 0,-0.983398 0.84941,-3.033545 1.86584,-3.033545 h 2.89625 z" />
                  </g>
                </g>
              </svg>
            </div>
            <a href="https://www.facebook.com/EugeneYesaulov"><h5>facebook.com/EugeneYesaulov</h5></a>
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col align="center" justify="center">
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d90384.83821335243!2d-123.09824688782035!3d44.93297004564136!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x54bffefcbc4b9c63%3A0xf93429e08f0357c2!2sSalem%2C%20OR!5e0!3m2!1sen!2sus!4v1595982960472!5m2!1sen!2sus" width="100%" height="300" frameborder="0" style="border:0;" allowfullscreen="" aria-hidden="false" tabindex="0"></iframe>
        </v-col>
      </v-row>
      <div style="height:20px;"><p> </p></div>
    </div>
</template>

<script>
    export default {
        name: "ContactsInformation"
    }
</script>

<style scoped>
    .v-application a {
        color: #ffffff;
    }
    a {
        text-decoration: none;
        color: #ffffff;
        text-align: center;
    }
    h5{
        height: 100%;
        vertical-align: middle;
        line-height: 30px; /* <-- adjust this */
    }
    a:hover {
        text-decoration:none;
        cursor:pointer;
        color: #e65100;
    }
    .contacts-info{
        margin-left: 20px;
        margin-right: 20px;
    }
    .entry-subheader{
        margin-top: 40px;
        display: flex;
    }
    .entry-subtitle{
        font-weight: 900;
        color: #ffffff;
        text-transform: lowercase;
        margin-bottom: 0;
        margin-left: 15px;
    }
    .icon-style{
        font-size: 2.2rem;
        color: #e65100;
    }
    .note-row{
        display: flex;
        margin-top: 15px;
        height: 30px;

    }
    .icon-row{
        color: #e65100;
        margin-right: 15px;
        height: 30px;
        width: 30px;
    }
    .description{
        color: #888888;
        line-height: 1.73;

    }
</style>
